import { render, staticRenderFns } from "./SearchSomeTextInLab.vue?vue&type=template&id=9a03e1fc"
import script from "./SearchSomeTextInLab.vue?vue&type=script&lang=js"
export * from "./SearchSomeTextInLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports